export default __webpack_public_path__ + "static/media/img2.431b1e24.jpeg";